module.exports = __webpack_public_path__ + "static/media/icon_79.adca7d9d.svg";